import { defineNuxtPlugin, useNuxtApp } from 'nuxt/app';
import { useRootStore } from '../stores/root';
import { setDdosHashCookie } from '~~/common/utils/ddosChecker';
import { useAwPerf } from '~~/common/composables/useAwPerf';

export default defineNuxtPlugin(async () => {
  const nuxtApp = useNuxtApp();

  const rootStore = useRootStore(nuxtApp.$pinia);
  if (import.meta.server) {
    const awPerf = useAwPerf();
    awPerf?.markPhase('ddosStart');
    await setDdosHashCookie(nuxtApp);
    awPerf?.markPhase('ddosDone');
    await rootStore.nuxtServerInit();
  } else {
    await rootStore.clientInit();
  }
});
